import Swal from "sweetalert2";

window.subscriptionRequired = () => Swal.fire({
    title: 'Attention',
    text: window.text.can_feature_error,
    icon: 'warning',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Upgrade',
    cancelButtonText: 'Cancel',
    /* confirmButtonClass: 'btn btn-success',
     cancelButtonClass: 'btn btn-danger',*/
    buttonsStyling: true,
    closeOnConfirm: false,
    closeOnCancel: false
}).then((result) => {
    if (result.value) {
        window.location.href = '/membership/plans'
    }
})